const icons = [
    {
        name: "DMPP",
        route: "./../assets/icons/cobs/Coberturas/danos_materiales.svg",
        shortname: "danos_materiales",
        image: require("./../assets/icons/cobs/Coberturas/danos_materiales.svg")
    },
    {
        name: "DMPT",
        route: "./../assets/icons/cobs/Coberturas/danos_materiales.svg",
        shortname: "danos_materiales",
        image: require("./../assets/icons/cobs/Coberturas/danos_materiales.svg")
    },
    {
        name: "RC",
        route: "./../assets/icons/cobs/Coberturas/rc.svg",
        shortname: "rc",
        image: require("./../assets/icons/cobs/Coberturas/rc.svg")
    },
    {
        name: "RT",
        route: "./../assets/icons/cobs/Coberturas/rt.svg",
        shortname: "rt",
        image: require("./../assets/icons/cobs/Coberturas/rt.svg")
    },
    {
        name: "GM",
        route: "./../assets/icons/cobs/Coberturas adicionales/gm.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/gm.svg")
    },
    {
        name: "EE",
        route: "./../assets/icons/cobs/Coberturas adicionales/ee.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/ee.svg")
    },
    {
        name: "ERC",
        route: "./../assets/icons/cobs/Coberturas adicionales/erc.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/erc.svg")
    },
    {
        name: "L10",
        route: "./../assets/icons/cobs/Coberturas adicionales/l10.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/l10.svg")
    },
    {
        name: "MA",
        route: "./../assets/icons/cobs/Coberturas adicionales/Accidentes al Conductor.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/Accidentes al Conductor.svg")
    },
    {
        name: "RCC",
        route: "./../assets/icons/cobs/Coberturas adicionales/Muerte a Terceros.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/Muerte a Terceros.svg")
    },
    {
        name: "RCF",
        route: "./../assets/icons/cobs/Coberturas adicionales/Muerte a Terceros.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/Muerte a Terceros.svg")
    },
    {
        name: "RCU",
        route: "./../assets/icons/cobs/Asistencias/RCUSA.svg",
        image: require("./../assets/icons/cobs/Asistencias/RCUSA.svg"),
        shortname: "Responsabilidad Civil USA"
    },
    {
        name: "RCZ",
        route: "./../assets/icons/cobs/Coberturas adicionales/Cuidando tus Bienes.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/Cuidando tus Bienes.svg")
    },
    {
        name: "RCO",
        route: "./../assets/icons/cobs/Coberturas adicionales/Protección a Ocupantes.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/Protección a Ocupantes.svg")
    },
    {
        name: "DCA",
        route: "./../assets/icons/cobs/Coberturas adicionales/Daños por Caída de Aditamentos.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/Daños por Caída de Aditamentos.svg")
    },
    {
        name: "ED",
        route: "./../assets/icons/cobs/Coberturas adicionales/Siempre Protegido.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/Siempre Protegido.svg")
    },
    {
        name: "RAS",
        route: "./../assets/icons/cobs/Coberturas adicionales/Agencia Segura.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/Agencia Segura.svg")
    },
    {
        name: "CARP",
        route: "./../assets/icons/cobs/Coberturas adicionales/Cobertura de Autopartes.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/Cobertura de Autopartes.svg")
    },
    {
        name: "AC",
        route: "./../assets/icons/cobs/Coberturas adicionales/Auto Constante.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/Auto Constante.svg")
    },
    {
        name: "DD",
        route: "./../assets/icons/cobs/Coberturas adicionales/Disminución de Deducible.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/Disminución de Deducible.svg")
    },
    {
        name: "AMC",
        route: "./../assets/icons/cobs/Coberturas adicionales/Adaptaciones, Modificaciones y_o Conversiones.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/Adaptaciones, Modificaciones y_o Conversiones.svg")
    },
    {
        name: "RS",
        route: "./../assets/icons/cobs/Coberturas adicionales/Rueda Segura.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/Rueda Segura.svg")
    },
    {
        name: "RCR",
        route: "./../assets/icons/cobs/Coberturas adicionales/Rueda Segura.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/Rueda Segura.svg")
    },
    {
        name: "PTT",
        route: "./../assets/icons/cobs/Asistencias/TrasladoSeguro.svg",
        image: require("./../assets/icons/cobs/Asistencias/TrasladoSeguro.svg"),
        shortname: "Traslado seguros ante cualquier imprevisto"
    },
    {
        name: "AI",
        route: "./../assets/icons/cobs/Asistencias/Asistencia Vial.svg",
        image: require("./../assets/icons/cobs/Asistencias/Asistencia Vial.svg")
    },
    {
        name: "DJ",
        route: "./../assets/icons/cobs/Asistencias/Asistencia Legal.svg",
        image: require("./../assets/icons/cobs/Asistencias/Asistencia Legal.svg")
    },
    {
        name: "RLL",
        route: "./../assets/icons/cobs/Coberturas adicionales/Recuperación de Llaves.svg",
        image: require("./../assets/icons/cobs/Coberturas adicionales/Recuperación de Llaves.svg")
    },
    {
        name: "AIP",
        route: "./../assets/icons/cobs/Asistencias/Asistenciavialplus.svg",
        image: require("./../assets/icons/cobs/Asistencias/Asistenciavialplus.svg"),
        shortname: "Asistencia vial plus"
    },
    {
        name: "TS",
        route: "./../assets/icons/cobs/Asistencias/TrasladoSeguro.svg",
        image: require("./../assets/icons/cobs/Asistencias/TrasladoSeguro.svg")
    },
    {
        name: "AFC",
        route: "./../assets/icons/cobs/Asistencias/Asistencia_funeraria_conductor.svg",
        image: require("./../assets/icons/cobs/Asistencias/Asistencia_funeraria_conductor.svg"),
        shortname: "Asistencia funeraria al conductor"
    },
    {
        name: "AFO",
        route: "./../assets/icons/cobs/Asistencias/Asistencia_funeraria_ocupantes.svg",
        image: require("./../assets/icons/cobs/Asistencias/Asistencia_funeraria_ocupantes.svg"),
        shortname: "Asistencia funeraria ocupantes"
    },
    {
        name: "SC",
        route: "./../assets/icons/cobs/Asistencias/Cuidando_tu_salud.svg",
        image: require("./../assets/icons/cobs/Asistencias/Cuidando_tu_salud.svg"),
        shortname: "Cuidando tu salud con grandes beneficios"
    },
    {
        name: "AM",
        route: "./../assets/icons/cobs/Asistencias/masCuidados.svg",
        image: require("./../assets/icons/cobs/Asistencias/masCuidados.svg"),
        shortname: "Protege tu hogar y mascotas"
    },
    {
        name: "AH",
        route: "./../assets/icons/cobs/Asistencias/Salud Contigo + Cuidados.svg",
        image: require("./../assets/icons/cobs/Asistencias/Salud Contigo + Cuidados.svg"),
        shortname: "Protege tu hogar y mascotas"
    },
    {
        name: "AV",
        route: "./../assets/icons/cobs/Asistencias/Cuidando_tu_vision.svg",
        image: require("./../assets/icons/cobs/Asistencias/Cuidando_tu_vision.svg"),
        shortname: "Cuida tu visión y obtén mejor tarifa"
    },
    {
        name: "AAE",
        route: "./../assets/icons/cobs/Asistencias/AutoxAuto.svg",
        image: require("./../assets/icons/cobs/Asistencias/AutoxAuto.svg"),
        shortname: "Auto x Auto en caso de reparación"
    },
];

export default icons;